import GalleryLayout from './GalleryLayout';

import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotFound } from 'features/NotFound';

const Gallery = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/business/:businessType?`}>
        <GalleryLayout />
      </Route>
      <Route exact path={`${path}`}>
        <GalleryLayout />
      </Route>
      <Route component={NotFound} />
    </Switch>
  );
};

export default Gallery;
